// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__29U2r","footer":"ReportModalFilter_footer__1Dg5P"};